import {QuestionCircleOutlined} from '@ant-design/icons';

import styled from 'styled-components';

export const StyledPopoverContainer = styled.div`
  padding: 12px 16px;

  border-radius: 4px;
`;

export const StyledQuestionCircleOutlined = styled(QuestionCircleOutlined)`
  margin-left: 10px;
`;
